import {DOM} from '../core/dom';

export namespace Intro {
  export function onload(type: 'freelancer' | 'company', callback: Function): void {
    if (window.location.href.includes('#signup')) {
      setTimeout(() => DOM.byId(`${type}-find-remote`).click())
    }
    DOM.onIdClick(`${type}-find-remote`, () => { callback(); });
  }
  
  export function contactUs(type: 'freelancer' | 'company', callback: Function): void {
    DOM.onIdClick(`${type}-contact-us`, () => { callback(); });
  }
}